import {compiler, MarkdownToJSX} from 'markdown-to-jsx'

import {Link} from '..'

import styles from './styles.module.css'

export type TMarkdownProps = {
  source: string
  inlineParagraph?: boolean
} & MarkdownToJSX.Options

export function Markdown({source, inlineParagraph, ...options}: TMarkdownProps) {
  return compiler(source?.split('\n').join('\n\n') || '', {
    wrapper: null,
    ...options,
    overrides: {
      ...(options.overrides || {}),
      ...(inlineParagraph
        ? {
            p: {
              props: {
                className: styles.inline,
              },
            },
          }
        : {}),
      a: {
        component: Link,
        props: {
          variant: 'light',
        },
      },
    },
  })
}

export const MD = Markdown
